import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=0155a570&scoped=true&"
import script from "./ConversationList.vue?vue&type=script&lang=js&"
export * from "./ConversationList.vue?vue&type=script&lang=js&"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=0155a570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155a570",
  null
  
)

export default component.exports